export default __webpack_public_path__ + "static/icon-20-6-48eac7fcfb1861ab40254103f17d9991.png";